import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from "reactstrap";
import { URL } from '../../api';
import Banner from '../../components/general/Banner';
import Celikler from '../../components/general/Celikler';
import { fetchPageGetSlug } from '../../redux/slices/pageGetSlugSlice';
import { fetchSeoGet } from '../../redux/slices/seoGetSlice';
import { LineCount } from '../../utilities/line-count';

const Partner = () => {
  const lang = useSelector((state) => state.lang.lang);
  const seo = useSelector((state) => state.seoGet.data);
  const [loading, setLoading] = useState(false);
  const page = useSelector((state) => state.pageGetSlug.data);
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true)
    await dispatch(fetchPageGetSlug({ slug: "is-ortaklarimiz" }));
    await dispatch(fetchSeoGet({ slug: "is-ortaklarimiz" }));
    setLoading(false)
  }

  useEffect(() => { getData() }, [])

  return (
    !loading ? <Celikler>
      {seo && seo.title && seo.description && (
        <Helmet>
          <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
          <meta name="description" content={seo.description?.[lang] || ""} />
          <meta name="keywords" content={seo.keywords?.[lang] || ""} />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
      )}
      <Banner title={page?.title[lang]} />
      <div className="solutions-container">
        <div className="textJustifyCenter partner-text mt-5">
          <div className="f24 d-flex align-items-center justify-content-center className='blueText'">
            <span className='color10 f32 fw500 mb-5'>{page?.showcases[0]?.title[lang]}</span>
          </div>
        </div>
        <Row className='d-flex justify-content-center align-items-center'>
          {
            (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
              .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
              .map((item, index) => {
                return (
                  <Col xs={12} sm={12} md={LineCount(page?.showcases[0]?.lineCount)} lg={LineCount(page?.showcases[0]?.lineCount)} xl={LineCount(page?.showcases[0]?.lineCount)} key={index} className="mb-4">
                    <div className="partner-item">
                      <img src={`${URL}${item?.files[0]}`} alt='' loading="lazy" />
                    </div>
                  </Col>
                )
              })
          }
        </Row>
      </div>
    </Celikler> : <div className="modern-spinner-wrapper">
      <div className="modern-spinner"></div>
    </div>
  );
};

export default Partner;
